/**
 * A dónde volver después de iniciar sesión.
 *
 * Cuando alguien llega a una pantalla protegida sin sesión —el caso típico es un
 * link de un mail— lo mandamos al login con el destino en `?next=`, y al entrar
 * lo devolvemos ahí. Sin esto, el mail que core le manda al Gran Proveedor
 * (`/ventas-b2b/solicitudes`) lo dejaba en el home después de loguearse, y la
 * solicitud que lo hizo entrar quedaba a tres clics de distancia.
 *
 * **Sólo rutas internas.** `next` viene de la URL, o sea del afuera: si se
 * aceptara cualquier valor, un link a
 * `nuestro-dominio/login?next=https://sitio-falso/...` mandaría al usuario a otro
 * host **después** de que puso la contraseña, que es la forma clásica de un
 * redirect abierto. Por eso se exige que empiece con una sola `/` y se rechaza
 * todo lo demás — incluido `//host`, que el browser lee como protocolo relativo
 * y sale del dominio igual.
 */

/** Destino por defecto cuando no hay `next`, o cuando el que vino no sirve. */
export const DESTINO_POR_DEFECTO = "/";

export function esDestinoInterno(next: string | null | undefined): boolean {
  if (!next) return false;
  const v = next.trim();
  // `/` sola no aporta nada; `//` y `/\` salen del dominio; el resto de los
  // esquemas (`javascript:`, `http:`) no arrancan con `/` y ya quedan afuera.
  if (v.length < 2) return false;
  if (!v.startsWith("/")) return false;
  if (v.startsWith("//") || v.startsWith("/\\")) return false;
  return true;
}

/** El destino a usar después del login: el de `next` si sirve, si no la home. */
export function destinoDespuesDelLogin(
  next: string | null | undefined
): string {
  return esDestinoInterno(next) ? next!.trim() : DESTINO_POR_DEFECTO;
}

/** `/login?next=<destino>` — o `/login` pelado si el destino es la home. */
export function urlDeLoginCon(destino: string): string {
  return esDestinoInterno(destino) && destino !== DESTINO_POR_DEFECTO
    ? `/login?next=${encodeURIComponent(destino)}`
    : "/login";
}
